import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-double-check-icon',
  templateUrl: './navigation-double-check.component.html'
})
export class NavigationDoubleCheckComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
